import { store$ } from '@redux/store';
import { distinctUntilChanged, filter, map } from 'rxjs';
import { selectedMarker } from '../redux/selectors';
import { saveViewedMarker } from '../services/markerSessionService';

/**
 * Subscribing to the store$ observable to listen for changes.
 * When the selectedMarker changes, map the selectedMarker and compare if the value has changed to valid value.
 * If that is the case run the savedViewdMarker function when the value is truly when an marker is active.
 */
store$
  .pipe(
    map(selectedMarker),
    distinctUntilChanged(),
    filter(marker => Boolean(marker?.id)))
  .subscribe(saveViewedMarker);